import * as client from "../../../client";

const REQUIRED_FIELDS: (keyof client.RawAddress)[] = [
  "aop_deductible",
  "premises_number",
  "building_number",
  "street_address",
  "city",
  "state",
  "zip",
  "year_built",
  "building_description",
  "construction_description",
  "cooking_class",
];

export const isRequiredField = (
  field: keyof client.RawAddress | undefined
): boolean => {
  return field !== undefined && REQUIRED_FIELDS.includes(field);
};
